import { Component, inject } from '@angular/core';
import { ModalComponent } from '../../../services/modal/modal.component';
import { MODAL_REF } from '../../../services/modal/modal.service';
import { ButtonComponent } from '@infinitform/shared-ui';

@Component({
    selector: 'app-example-project-copy-modal',
    templateUrl: './example-project-copy-modal.component.html',
    imports: [ModalComponent, ButtonComponent]
})
export class ExampleProjectCopyModalComponent {
  private modalRef = inject(MODAL_REF);

  copyToMyProjects(): void {
    this.modalRef.close('copy');
  }

  cancel(): void {
    this.modalRef.close('cancel');
  }
}
